import { OWN_TRACTOR_SURVEY_FEATURE_VERSION } from '../../constants/tempData/tempData.contant';
import { IUserOwnTractorTempData } from '../../interfaces/Element.interfaces';
import { userOwnTractorSurveyStateType } from '../../store/userOwnTractorSurveySlice';

export interface ICreateUserOwnTractorTempDataParam {
  formData: userOwnTractorSurveyStateType;
}

interface ICreateUserOwnTractorTempDataReturn {
  newOwnTractorTempData: string;
}

export const createUserOwnTractorTempData = ({
  formData,
}: ICreateUserOwnTractorTempDataParam): ICreateUserOwnTractorTempDataReturn => {
  const ownTractorTempData: IUserOwnTractorTempData = {
    version: OWN_TRACTOR_SURVEY_FEATURE_VERSION,
    createDate: new Date(),
    formData,
  };
  return { newOwnTractorTempData: JSON.stringify(ownTractorTempData) };
};
